import { render, staticRenderFns } from "./UserPaymentsTable.vue?vue&type=template&id=3e808da4&"
import script from "./UserPaymentsTable.vue?vue&type=script&lang=js&"
export * from "./UserPaymentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports